import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">My Pro Headshots</p>
        <h1>Elevate Your Professional Image</h1>
        <p className="lede">
          Capture the essence of your professionalism with stunning headshots tailored for business professionals and actors. Stand out in your industry with a captivating image that speaks volumes.
        </p>
        <div className="cta-row">
          <a href="/portfolio" target="_self">
            View Our Portfolio
          </a>
          <a href="/book" target="_self" className="secondary">
            Book Your Session
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Professional Quality</h2>
          <p>
            Our experienced photographers use top-of-the-line equipment to ensure your headshot reflects your best self.
          </p>
        </article>
        <article>
          <h2>Tailored Experience</h2>
          <p>
            We work with you to understand your vision and deliver a headshot that aligns with your personal brand.
          </p>
        </article>
        <article>
          <h2>Fast Turnaround</h2>
          <p>
            Receive your professionally edited images quickly, so you can start making an impression right away.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;